
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.293 5.293A1 1 0 0114 6v5a1 1 0 001 1h3a1 1 0 01.997.918l-.974 4.869c-.112.467-.308.808-.508 1.007-.192.192-.343.217-.43.21A1 1 0 0017 19h-7a2 2 0 01-2-2v-5.101A5 5 0 0012 7V6a1 1 0 01.293-.707zM7.414 20.414c.068-.067.13-.139.186-.214a4 4 0 002.4.8h6.963c.76.05 1.449-.274 1.967-.792.52-.52.867-1.227 1.044-1.98l.004-.018.003-.014 1-5A1 1 0 0021 13a3 3 0 00-3-3h-2V6a3 3 0 00-6 0v1a3 3 0 01-3 3H4a2 2 0 00-2 2v7a2 2 0 002 2h2a2 2 0 001.414-.586zM6 12v7H4v-7h2z","fill":"#E6615E"}})])
          )
        }
      }
    